// Backend limit on an event's `participantInfo` (invi-nodejs-api#85): longer
// gives a 422
export const PARTICIPANT_INFO_MAX_LENGTH = 2000
